import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import locale from "@amcharts/amcharts4/lang/pt_BR.js";
import { customizeChartGrip } from "../../utils/customizeChartGrip";


export function montarGraficoDiaFP({ id, lista, zoomFP, isMobile, setZoomFP, setGraficoFP }) {
    const corPrimaria = "#13b4d1";
    am4core.useTheme(am4themes_animated);

    const modoSimulado = lista[0] && !isNaN(parseFloat(lista[0].q_simulado)); //se tem q_simulado a lista está no modo simulada

    let chart = am4core.create(id, am4charts.XYChart);

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix = "Gráfico";
    chart.exporting.menu.align = "right";
    chart.exporting.menu.verticalAlign = "top";
    chart.language.locale = locale;
    chart.language.locale["_decimalSeparator"] = ",";
    chart.language.locale["_thousandSeparator"] = ".";
    chart.numberFormatter.numberFormat = "###,###,###,###.00";

    // Configuração do eixo X (tempo)
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.startLocation = 0.5;
    dateAxis.endLocation = 0.5;
    // dateAxis.baseInterval = { timeUnit: "minute", count: 15 };

    if (lista.length) {
        const firstDate = new Date(lista[0].data_hora);
        const lastDate = new Date(lista[lista.length - 1].data_hora);
        const isSingleDay = firstDate.toDateString() === lastDate.toDateString();

        if (isSingleDay) {
            dateAxis.dateFormats.setKey("hour", "HH:mm");
            dateAxis.dateFormats.setKey("minute", "HH:mm");
        } else {
            dateAxis.dateFormats.setKey("day", "dd/MM\nEEE");
        }
    }

    dateAxis.renderer.labels.template.textAlign = "middle";

    // Eixo Y para FP positiva (metade superior)
    const valueAxisPositivo = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxisPositivo.renderer.labels.template.fill = am4core.color("#000");
    valueAxisPositivo.renderer.minGridDistance = 30;
    valueAxisPositivo.min = zoomFP ? 0.9 : 0;
    valueAxisPositivo.max = 1;
    valueAxisPositivo.strictMinMax = true;
    valueAxisPositivo.extraMin = 0; // Restringe à metade superior
    valueAxisPositivo.extraMax = 1; // Evita ocupar todo o espaço
    valueAxisPositivo.renderer.opposite = false;
    valueAxisPositivo.renderer.inversed = true;
    valueAxisPositivo.marginTop = 0;
    if (!isMobile) {
        valueAxisPositivo.title.text = "FP";
    }

    // **Ocultar labels fora da faixa -1 a 0**
    valueAxisPositivo.renderer.labels.template.adapter.add("text", function (text, target) {
        let value = target.dataItem.value;
        return value >= 0 && value <= 1 && value != 0.9 ? text : "";
    });

    // Eixo Y para FP negativa (metade inferior)
    const valueAxisNegativo = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxisNegativo.renderer.labels.template.fill = am4core.color("#000");
    valueAxisNegativo.renderer.minGridDistance = 30;
    valueAxisNegativo.min = -1;
    valueAxisNegativo.max = zoomFP ? -0.9 : 0;
    valueAxisNegativo.strictMinMax = true;
    valueAxisNegativo.extraMin = 1; // Evita ocupar todo o espaço
    valueAxisNegativo.extraMax = 0; // Restringe à metade inferior
    valueAxisNegativo.renderer.opposite = false;
    valueAxisNegativo.renderer.inversed = true;
    valueAxisNegativo.marginBottom = 0;

    // **Ocultar labels fora da faixa -1 a 0**
    valueAxisNegativo.renderer.labels.template.adapter.add("text", function (text, target) {
        let value = target.dataItem.value;
        return value <= 0 && value > -1 && value != -0.9 ? text : "";
    });

    valueAxisPositivo.renderer.labels.template.dx = 30; // Ajuste fino conforme necessário
    valueAxisNegativo.renderer.labels.template.dx = -17; // Mesmo valor para ambos os eixos

    valueAxisPositivo.renderer.grid.template.width = valueAxisNegativo.renderer.grid.template.width;

    if (isMobile) {
        // Eixo X
        dateAxis.renderer.labels.template.fontSize = 10;

        // Eixo Y positivo
        valueAxisPositivo.renderer.labels.template.fontSize = 10;

        // Eixo Y negativo
        valueAxisNegativo.renderer.labels.template.fontSize = 10;

        // Remove padding do gráfico
        chart.paddingLeft = -30;

        // Coloca labels do eixo Y para dentro do gráfico
        // valueAxisPositivo.renderer.inside = true;
        // valueAxisNegativo.renderer.inside = true;

        // Remove deslocamento manual
        valueAxisPositivo.renderer.labels.template.dx = 40; // Ajuste fino conforme necessário
        valueAxisNegativo.renderer.labels.template.dx = 0; // Mesmo valor para ambos os eixos

        // // Reduz distância mínima
        // valueAxisPositivo.renderer.minLabelPosition = 0.01;
        // valueAxisNegativo.renderer.minLabelPosition = 0.01;
    }

    // Criar a faixa no eixo para destacar 0.92
    let range1 = valueAxisPositivo.axisRanges.create();
    let range2 = valueAxisNegativo.axisRanges.create();

    range1.value = 0.92;
    range2.value = -0.92;
    range1.grid.strokeOpacity = 0.2; // Mantém uma linha visível na posição
    range2.grid.strokeOpacity = 0.2;
    range1.label.text = "0,92";
    range2.label.text = "-0,92";

    // Criar a faixa no eixo para destacar -0.92
    if (!zoomFP) {
        range1.label.dy = 8; // Move um pouco para baixo
        range1.label.verticalCenter = "bottom"; // Alinha a parte superior do texto com a linha
        range1.label.fontSize = isMobile ? 10 : 12; // Ajusta o tamanho do texto para melhor visibilidade

        range2.label.dy = -8; // Move um pouco para baixo
        range2.label.verticalCenter = "top"; // Alinha a parte superior do texto com a linha
        range2.label.fontSize = isMobile ? 10 : 12;
    }

    // Criando a faixa no background (guide)
    let rangeP = valueAxisPositivo.axisRanges.create();
    rangeP.value = 0.92; // Início da faixa
    rangeP.endValue = 1; // Fim da faixa
    rangeP.axisFill.fill = am4core.color("#ffa1a0"); // Cor da faixa
    rangeP.axisFill.fillOpacity = 0.5; // Define a transparência
    rangeP.grid.disabled = true; // Remove linhas extras para evitar poluição visual

    // Criando a faixa no background (guide)
    let rangeN = valueAxisNegativo.axisRanges.create();
    rangeN.value = -0.92; // Início da faixa
    rangeN.endValue = -1; // Fim da faixa
    rangeN.axisFill.fill = am4core.color("#ffa1a0"); // Cor da faixa
    rangeN.axisFill.fillOpacity = 0.5; // Define a transparência
    rangeN.grid.disabled = true; // Remove linhas extras para evitar poluição visual

    // Série para FP positiva
    const seriesPositivo = chart.series.push(new am4charts.LineSeries());
    seriesPositivo.dataFields.valueY = "fpPositivo";
    seriesPositivo.dataFields.dateX = "data_hora";
    seriesPositivo.name = "Fator de Potência";
    seriesPositivo.tooltipText = `Fator de Potência (FP) às {dateX.formatDate("dd/MM/yyyy HH:mm")}h: [bold]{valueY.formatNumber("###,###,###,###.00")} [/]`;
    seriesPositivo.strokeWidth = 2;
    seriesPositivo.stroke = am4core.color(corPrimaria);
    seriesPositivo.fill = am4core.color(corPrimaria);
    seriesPositivo.yAxis = valueAxisPositivo;
    seriesPositivo.baseValue = 0;
    seriesPositivo.connect = false;

    // Exibe apenas a legenda da série positiva
    seriesPositivo.showOnLegend = true; // A série positiva aparece na legenda

    // Série para FP negativa
    const seriesNegativo = chart.series.push(new am4charts.LineSeries());
    seriesNegativo.dataFields.valueY = "fpNegativo";
    seriesNegativo.dataFields.dateX = "data_hora";
    seriesNegativo.name = "Fator de Potência";
    seriesNegativo.tooltipText = `Fator de Potência (FP) às {dateX.formatDate("dd/MM/yyyy HH:mm")}h: [bold]{valueY.formatNumber("###,###,###,###.00")} [/]`;
    seriesNegativo.strokeWidth = 2;
    seriesNegativo.stroke = am4core.color("#d11313");
    seriesNegativo.fill = am4core.color("#d11313");
    seriesNegativo.yAxis = valueAxisNegativo;
    seriesNegativo.baseValue = 0;
    seriesNegativo.connect = false;
    seriesNegativo.showOnLegend = false; // A série negativa não aparece na legenda

    // Adiciona cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.snapToSeries = [seriesPositivo, seriesNegativo];
    chart.cursor.behavior = "none"; // Desativa o zoom ao arrastar
    chart.chartContainer.wheelable = false; // Bloqueia zoom pelo scroll do mouse

    //-------------------------------------------------------------------USADO NO SIMULADOR---------------------------------------------------------------------
    if (modoSimulado) {
        // Série para FP positiva
        const seriesPositivoSimulado = chart.series.push(new am4charts.LineSeries());
        seriesPositivoSimulado.dataFields.valueY = "fpPositivoSimulado";
        seriesPositivoSimulado.dataFields.dateX = "data_hora";
        seriesPositivoSimulado.name = "Fator de Potência Simulado";
        seriesPositivoSimulado.tooltipText = `Fator de Potência (FP) às {dateX.formatDate("dd/MM/yyyy HH:mm")}h: [bold]{valueY.formatNumber("###,###,###,###.00")} [/]`;
        seriesPositivoSimulado.strokeWidth = 2;
        seriesPositivoSimulado.stroke = am4core.color("#ff0077");
        seriesPositivoSimulado.fill = am4core.color("#ff0077");
        seriesPositivoSimulado.yAxis = valueAxisPositivo;
        seriesPositivoSimulado.baseValue = 0;
        seriesPositivoSimulado.connect = false;
        seriesPositivoSimulado.showOnLegend = true; // A série positiva aparece na legenda

        // Série para FP negativa
        const seriesNegativoSimulado = chart.series.push(new am4charts.LineSeries());
        seriesNegativoSimulado.dataFields.valueY = "fpNegativoSimulado";
        seriesNegativoSimulado.dataFields.dateX = "data_hora";
        seriesNegativoSimulado.name = "Fator de Potência Simulado";
        seriesNegativoSimulado.tooltipText = `Fator de Potência (FP) às {dateX.formatDate("dd/MM/yyyy HH:mm")}h: [bold]{valueY.formatNumber("###,###,###,###.00")} [/]`;
        seriesNegativoSimulado.strokeWidth = 2;
        seriesNegativoSimulado.stroke = am4core.color("#ff0077");
        seriesNegativoSimulado.fill = am4core.color("#ff0077");
        seriesNegativoSimulado.yAxis = valueAxisNegativo;
        seriesNegativoSimulado.baseValue = 0;
        seriesNegativoSimulado.connect = false;
        seriesNegativoSimulado.showOnLegend = false; // A série negativa não aparece na legenda

        chart.cursor.snapToSeries.push(seriesPositivoSimulado, seriesNegativoSimulado);
    }

    //----------------------------------------------------------------------------------------------------------------------------------------------------------

    // Prepara os dados normalizando corretamente
    chart.data = lista.map((leitura, i) => {
        const { p, q, q_simulado, data_hora } = leitura;
        const fp = (p / Math.sqrt(Math.pow(p, 2) + Math.pow(q, 2))) * (q >= 0 ? 1 : -1);
        const fpSimulado = (p / Math.sqrt(Math.pow(p, 2) + Math.pow(q_simulado, 2))) * (q_simulado >= 0 ? 1 : -1);

        return {
            fpPositivo: fp >= 0 ? fp : null,
            fpNegativo: fp < 0 ? fp : null,
            fpPositivoSimulado: fpSimulado >= 0 ? fpSimulado : null,
            fpNegativoSimulado: fpSimulado < 0 ? fpSimulado : null,
            data_hora: new Date(data_hora),
        };
    });

    // Scrollbar
    chart.scrollbarX = new am4charts.XYChartScrollbar();
    chart.scrollbarX.series.push(seriesPositivo);
    chart.scrollbarX.series.push(seriesNegativo);
    chart.scrollbarX.unselectedOverlay.fill = am4core.color("#fff");
    chart.scrollbarX.unselectedOverlay.fillOpacity = 0.7;
    chart.scrollbarX.unselectedOverlay.stroke = am4core.color("#fff");

    chart.scrollbarX.background.fill = am4core.color("#fff");
    chart.scrollbarX.thumb.background.fill = am4core.color(corPrimaria);
    chart.scrollbarX.thumb.background.fillOpacity = 0.3;
    chart.scrollbarX.stroke = am4core.color(corPrimaria);
    chart.scrollbarX.strokeWidth = 0;

    chart.scrollbarX.startGrip.background.states.getKey("hover").properties.fill = am4core.color(corPrimaria);
    chart.scrollbarX.startGrip.background.states.getKey("hover").properties.fillOpacity = 0.3;
    chart.scrollbarX.endGrip.background.states.getKey("hover").properties.fill = am4core.color(corPrimaria);
    chart.scrollbarX.endGrip.background.states.getKey("hover").properties.fillOpacity = 0.3;
    chart.scrollbarX.thumb.background.states.getKey("hover").properties.fill = am4core.color(corPrimaria);
    chart.scrollbarX.thumb.background.states.getKey("hover").properties.fillOpacity = 0.3;

    // Adiciona legenda
        chart.legend = new am4charts.Legend();
        chart.legend.labels.template.fill = am4core.color("#000");
        chart.legend.valueLabels.template.fill = am4core.color("#000");
    chart.legend.dx = 100;
    if (isMobile) {
        chart.legend.labels.template.fontSize = 10;
        chart.legend.valueLabels.template.fontSize = 10;
    }
    // Configura a cor do tooltip do eixo X
    const dateAxisTooltip = dateAxis.tooltip;
    dateAxisTooltip.background.fill = am4core.color("#0070cc");
    dateAxisTooltip.stroke = am4core.color("#fff");
    dateAxisTooltip.background.strokeWidth = 0;
    dateAxisTooltip.background.cornerRadius = 3;
    dateAxisTooltip.background.pointerLength = 0;
    // dateAxisTooltip.dy = 5;

    // Configura a cor do tooltip do eixo Y compartilhado
    const valueAxisTooltip = valueAxisPositivo.tooltip;
    valueAxisTooltip.background.fill = am4core.color("#0070cc");
    valueAxisTooltip.stroke = am4core.color("#fff");
    valueAxisTooltip.background.strokeWidth = 0;
    valueAxisTooltip.background.cornerRadius = 3;
    valueAxisTooltip.background.pointerLength = 0;
    valueAxisTooltip.dy = 5;
    // valueAxisPositivo.renderer.line.strokeOpacity = 1;
    // valueAxisPositivo.renderer.line.strokeWidth = 1;

    // A legenda deve ser configurada após as séries
    chart.legend.itemContainers.template.adapter.add("visible", function (visible, target) {
        // Só mostrar a legenda se a série estiver visível
        return target.dataItem && target.dataItem.dataContext.showOnLegend ? visible : false;
    });

    // Desabilitar o clique na legenda
    chart.legend.itemContainers.template.clickable = false;
    chart.legend.itemContainers.template.focusable = false;
    chart.legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;

    chart.chartContainer.events.on("wheel", function (ev) {
        if (ev.event.deltaY > 0) {
            // Rolando para baixo (scroll para frente)
            setZoomFP(false);
        } else {
            // Rolando para cima (scroll para trás)
            setZoomFP(true);
        }
    });

    dateAxis.start = 0;
    dateAxis.end = 1;
    dateAxis.keepSelection = true; // Impede que o usuário altere o zoom

    valueAxisPositivo.start = 0;
    valueAxisPositivo.end = 1;
    valueAxisPositivo.keepSelection = true;

    valueAxisNegativo.start = 0;
    valueAxisNegativo.end = 1;
    valueAxisNegativo.keepSelection = true;

    // Customiza botões da scrollbar
    customizeChartGrip(chart.scrollbarX.startGrip, corPrimaria);
    customizeChartGrip(chart.scrollbarX.endGrip, corPrimaria);

    return setGraficoFP(chart);
}
